<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Motivation' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="motivation ck-content" *ngIf="data.motivation" [innerHTML]="data.motivation">

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-end">
      <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">{{'Close' | translate}}</button>
    </div>
  </div>
</div>


